import type { IconData } from '@stacksjs/iconify-core'

export const mergeF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M9.033 5.817v2.028q0 .111-.008.221a1 1 0 0 0 .462.637l3.086 1.846a3 3 0 0 1 1.46 2.575v1.059a3.001 3.001 0 1 1-2-.024v-1.035a1 1 0 0 0-.487-.858L8.46 10.42a3 3 0 0 1-.444-.324a3 3 0 0 1-.443.324l-3.086 1.846a1 1 0 0 0-.487.858v1.047a3.001 3.001 0 1 1-2 0v-1.047a3 3 0 0 1 1.46-2.575l3.086-1.846a1 1 0 0 0 .462-.637A3 3 0 0 1 7 7.845V5.829a3.001 3.001 0 1 1 2.033-.012\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default mergeF
